import styles from './PersonSearch.module.scss'
import Date from "@/Atoms/Date/Date";
import TextInput from "@/Atoms/Input/TextInput";

import Button from "@/Atoms/Input/Button";
import {FormEvent, useState} from "react";
import Select, {ListOption} from "@/Atoms/Select/Select";
import {ObituarySearchType} from "@/Pages/Obituary/Overview";
import Checkbox from "@/Components/Checkbox";
import InputError from "@/Components/InputError";
import provinceList from "@/helpers/provinceList";
import PlaceSelect from "@/Atoms/Select/PlaceSelect";
import MultiPlaceOrRegionSelect from "@/Atoms/Select/MultiPlaceOrRegionSelect";


export default (
  {
    data,
    errors,
    setData,
    reset,
    onSubmit,
    papers,
    simple
  }: {
  data: ObituarySearchType,
  errors: any,
  setData: (key: string, value: any|undefined|string|string[]) => void,
  reset: () => void,
  onSubmit: () => void,
  papers: ListOption[]
  simple?: boolean
}) => {

  const [extended, setExtended] = useState(!simple)
  const provinces = provinceList();

  function handleSetPapers(papers: ListOption[]) {
    setData('papers', papers.map((paper: ListOption) => paper.value))
  }

  const handleSetPlaces = (places: any) => {
    setData('places', places)
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit();
  }



  return <div className={'search'}>
    <form
      className={`${styles.grid} ${!extended && styles.simple}`}
      onSubmit={handleSubmit}
      autoComplete={'off'}
    >
      <div className={styles.firstName}>
        <label>Voornaam</label>
        <TextInput
          value={data.firstName}
          name={'first_name'}
          onChange={(e) => setData('firstName', e.target.value)}
        />
        <InputError message={errors.firstName}/>
      </div>
      <div className={styles.lastName}>
        <label>Achternaam</label>
        <TextInput
          value={data.lastName}
          name={'last_name'}
          onChange={(e) => setData('lastName', e.target.value)}
        />
        <InputError message={errors.lastName}/>
      </div>
      <div className={styles.papers}>
        <label>Geplaatst in</label>
        <Select
          placeholder={'Zoek naar krant of dagblad'}
          name={'papers'}
          isClearable
          isMulti
          options={papers}
          value={papers.filter(paper => data.papers.includes(paper.value))}
          onChange={(papers: ListOption[] | any) => handleSetPapers(papers)}
          noOptionsMessage={() => 'Geen zoekresultaten'}
         dataTestid={'papers-select'}/>
        <InputError message={errors.papers}/>
      </div>
      <div className={styles.place}>
        <label>Plaats of Gemeente</label>
        <MultiPlaceOrRegionSelect
          dataTestid={'places'}
          value={data.places ?? null}
          onChange={(places: any) => handleSetPlaces(places)}
        />

      </div>
      <div className={styles.province}>
        <label>Provincie</label>
        <Select
          name={'provinces'}
          dataTestid={'province-select'}
          isClearable
          options={provinces}
          getOptionValue={(option: any) => option.id}
          getOptionLabel={(option: any) => option.title}
          value={provinces.find(province => province.id === data.province) ?? null}
          onChange={(province: any) => setData('province', province?.id)}
        />
        <InputError message={errors.province}/>
      </div>
      <div className={styles.birthDate}>
        <label>Geboortedatum</label>
        <Date
          type={'birthdate'}
          value={data.birthDate}
          onChange={(value) => setData('birthDate', value)}
        />
        <InputError message={errors.birthDate}/>

      </div>
      <div className={styles.dateOfPlacing}>
        <label>Specifieke plaatsingsdatum</label>
        <Date
          value={data.dateOfPlacing}
          onChange={(value) => setData('dateOfPlacing', value)}
        />
        <InputError message={errors.dateOfPlacing}/>
      </div>
      <div className={styles.deceasedFrom}>
        <label>Overlijdensdatum vanaf</label>
        <Date
          value={data.deceasedFrom}
          onChange={(value) => setData('deceasedFrom', value)}
        />
        <InputError message={errors.deceasedFrom}/>
      </div>
      <div className={styles.deceasedTo}>
        <label>Overlijdensdatum t/m</label>
        <Date
          value={data.deceasedTo}
          onChange={(value) => setData('deceasedTo', value)}
        />
        <InputError message={errors.deceasedTo}/>
      </div>
      <div className={styles.options}>
        <Checkbox
          className={'rounded-sm !border border-gray-900 text-indigo-600 shadow-xs focus:ring-indigo-500'}
          name="fuzzy_search"
          id={'fuzzy-search'}
          checked={data.fuzzySearch}
          onChange={(e) => setData('fuzzySearch', e.target.checked)}
        />
        <label htmlFor={'fuzzy-search'}>
          <span className="ms-2 text-sm text-gray-600">Ruimer zoeken</span>
        </label>
      </div>
      <div className={styles.actions}>
        <Button outlined onClick={() => reset()} data-testid={'reset'}>Alles wissen</Button>
        <Button type={'submit'} primary>Zoeken</Button>
      </div>
    </form>
  </div>

}
